import {
  barChartPalette,
  secondaryBarChartPalette,
} from '@legacy/constants/colors';

export const chartSetting = (alignment: string = 'reg') => ({
  height: 300,
  margin: { left: 30, top: 0 },
  colors: alignment === 'reg' ? barChartPalette : secondaryBarChartPalette,
});
